// import { store } from "@/root/store";
// import { selectMmServiceEnabledOnCourses } from "@/root/store/selectors";
import moment from "moment";
export const LIVE_STACKTYPES = {
  AMS: 0,
  AGORA: 1,
  HMS: 2,
};

export const newLiveStackTypes = {
  agora: "agora",
  ams: "ams",
  hms: "hms",
};

export const newLiveClassType = {
  course: "course",
  batch: "batch",
};

export const getLiveCardIsAgora = (liveCard) => liveCard?.isAgora;
export const getLiveCardDeepLink = (liveCard) => liveCard?.cta?.deeplink;
export const getLiveCardCtaText = (liveCard) => liveCard?.cta?.text;
export const getLiveCardDeepLinkParamOne = (liveCard) =>
  liveCard?.cta?.deeplink?.paramOne;
export const getLiveCardDeepLinkParamThree = (liveCard) =>
  liveCard?.cta?.deeplink?.paramThree;
export const getLiveCardDeepLinkParamTwo = (liveCard) =>
  liveCard?.cta?.deeplink?.paramTwo;

export const getLiveCardDeepLinkParamList = (liveCard, ctaName = "cta") => {
  try {
    return liveCard?.[ctaName]?.deeplink?.paramList && JSON?.parse(liveCard?.[ctaName]?.deeplink?.paramList);
  } catch (err) {
    console.error(err);
    return undefined;
  }
};

export const getNewLiveCardStackType = (liveCard, ctaName = "cta") =>
  /** @type {keyof typeof newLiveStackTypes} */
  (getLiveCardDeepLinkParamList(liveCard, ctaName)?.stackType);
export const getNewLiveCardSessionId = (liveCard) =>
  getLiveCardDeepLinkParamList(liveCard)?.sessionId;
export const getNewLiveCardScheduleTimeInEpoch = (liveCard) => {
  const t = getLiveCardDeepLinkParamList(liveCard)?.scheduleTime;
  return typeof t === "string" ? new Date(t).getTime() : t;
};
export const getNewLiveCardAlertText = (liveCard) =>
  getLiveCardDeepLinkParamList(liveCard)?.alertText;
export const getNewLiveCardRejoinInBinary = (liveCard, cta = "cta") => {
  const v = getLiveCardDeepLinkParamList(liveCard, cta)?.rejoin;
  return v !== undefined ? (v ? 1 : 0) : v;
};
export const getNewLiveCardEntityType = (liveCard) =>
  getLiveCardDeepLinkParamList(liveCard)?.entityType;
export const getNewLiveCardEntityName = (liveCard) =>
  getLiveCardDeepLinkParamList(liveCard)?.entityName;
export const getNewLiveCardIsScheduled = (liveCard) =>
  getLiveCardDeepLinkParamList(liveCard)?.isScheduled;
export const getNewLiveCardTitle = (liveCard) =>
  getLiveCardDeepLinkParamList(liveCard)?.title;

export const getOldStackTypeFromNew = (newStckTpe) => {
  switch (newStckTpe) {
    case newLiveStackTypes.agora:
      return LIVE_STACKTYPES.AGORA;
    case newLiveStackTypes.ams:
      return LIVE_STACKTYPES.AMS;
    case newLiveStackTypes.hms:
      return LIVE_STACKTYPES.HMS;
    default:
      return LIVE_STACKTYPES.AGORA;
  }
};

export const convertEpochToScheduleTime = (epochTime) => {
  if (epochTime.toString().length == 10) {
    epochTime = epochTime * 1000;
  }
  return moment(epochTime).format("DD MMM'YY");
};

export const getLiveCardOldStackTypeFromNew = (liveCard, ctaName = "cta") =>
  getOldStackTypeFromNew(getNewLiveCardStackType(liveCard, ctaName));

// export const checkMmServiceEnabledOnCourses = () =>{
//   return selectMmServiceEnabledOnCourses(store.getState())
// }